import React from "react"
import styled from "styled-components"
import { display, verticalAlign } from "styled-system"

import { TextProps } from ".."
import { typography, textTransform, textDecoration, whiteSpace, FontConfigurations } from "theme"

export const Text = styled.p<TextProps>`
  ${typography}
  ${display}
  ${textTransform}
  ${textDecoration}
  ${verticalAlign}
  ${whiteSpace}

  ${props => props.bold && "font-weight: bold"}
  ${props => props.italic && "font-style: italic"}
  ${props => (props.strikethrough ? "text-decoration: line-through;" : "")}
  ${props => (props.upperCase ? "text-transform: uppercase;" : "")}
`

export const ParagraphWithHTML: React.FunctionComponent<TextProps> = ({ children, ...props }) => (
  <Text {...FontConfigurations.p} {...props} dangerouslySetInnerHTML={{ __html: children as string }} />
)

export const Paragraph: React.FunctionComponent<TextProps> = ({ children, ...props }) => (
  <Text {...FontConfigurations.p} {...props}>
    {children}
  </Text>
)

export const ParagraphLarge: React.FunctionComponent<TextProps> = ({ children, ...props }) => (
  <Text {...FontConfigurations.pLg} {...props}>
    {children}
  </Text>
)

export const ParagraphSmall: React.FunctionComponent<TextProps> = ({ children, ...props }) => (
  <Text {...FontConfigurations.pSm} {...props}>
    {children}
  </Text>
)

export const Eyebrow: React.FunctionComponent<TextProps> = ({ children, as = "label", ...props }) => (
  <Text as={as} {...FontConfigurations.eyebrow} {...props}>
    {children}
  </Text>
)

export const EyebrowSmall: React.FunctionComponent<TextProps> = ({ children, as = "label", ...props }) => (
  <Text as={as} {...FontConfigurations.eyebrowSm} {...props}>
    {children}
  </Text>
)

export const Meta: React.FunctionComponent<TextProps> = ({ children, as = "label", ...props }) => (
  <Text as={as} {...FontConfigurations.meta} {...props}>
    {children}
  </Text>
)

/*
 * To pass in `as` as prop, I think we should rename to `asEl`
 * or something similar to avoid conflicting with default prop,
 * currently this doesn't work as implemented...
 */

export const CTA: React.FunctionComponent<TextProps> = ({ children, as = "button", ...props }) => (
  <Text as={as} {...FontConfigurations.p} {...props}>
    {children}
  </Text>
)
